





































import "./assignment-tracker-filter.less";
import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "AssignmentTrackerFilter",
  components: {},
  props: {},
  data() {
    return {
      keepUpdated: true,
      viewType: "open",
      currentTrackerId: null,
      showFilterPoptip: false,
    };
  },
  computed: {
    ...mapState("review", ["loading", "currentReview", "currentReviewMembers"]),
  },
  watch: {
    currentReview(newValue) {
      const context = this as any;
      if (newValue) {
        context.currentTrackerId = abp.session.userId;
        if (!context.currentReviewMembers.find((member) => member.id == context.currentTrackerId)) {
          context.currentTrackerId = context.currentReviewMembers.length > 0 ? context.currentReviewMembers[0].id : null;
        }

        if (this.viewType === "completed" && this.keepUpdated === true) {
          this.$emit("refresh");
        }
      }
    },
    currentTrackerId() {
      this.emitFilter(true);
    },
    viewType() {
      this.emitFilter(this.viewType === "completed");
    },
  },
  methods: {
    emitFilter(refresh) {
      this.$emit("filter", { viewType: this.viewType, trackerId: this.currentTrackerId });
      if (refresh === true) {
        this.$emit("refresh");
      }
    },
    handleRefreshClick() {
      this.$emit("refresh");
    },
  },
});
